import Enumerator from './Enumerator';

export const typesOfCertificateOfTitle = [
  'none',
  'company',
  'old_law',
  'qualified',
  'torrens',
  'unregistered'
];

export class TypeOfCertificateOfTitle extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case '1':
        correctOption = 'company';
        break;
      case '2':
        correctOption = 'old_law';
        break;
      case '3':
        correctOption = 'qualified';
        break;
      case '4':
        correctOption = 'torrens';
        break;
      case '5':
        correctOption = 'unregistered';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

TypeOfCertificateOfTitle.initEnum({
  none: {
    get title() {
      return 'Select one';
    }
  },
  company: {
    get title() {
      return 'Company';
    }
  },
  old_law: {
    get title() {
      return 'Old law';
    }
  },
  qualified: {
    get title() {
      return 'Qualified';
    }
  },
  torrens: {
    get title() {
      return 'Torrens';
    }
  },
  unregistered: {
    get title() {
      return 'Unregistered';
    }
  }
});

export default {
  typesOfCertificateOfTitle,
  TypeOfCertificateOfTitle
};
